import { Injectable } from "@angular/core";
import { UnsavedChangesModalComponent } from "@tva/ng-migration/shared/components/unsaved-changes-modal/unsaved-changes-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { take } from "rxjs/operators";
import { StateService } from "@tva/ng-migration/core/services/state/state.service";
import { RootScopeService } from "@tva/ng-migration/core/services/rootscope/rootscope.service";

@Injectable({
  providedIn: "root",
})
export class UnsavedChangesService {
  private unsavedChanges = false;
  private message;

  constructor(private dialog: MatDialog, private state: StateService, private rootScope: RootScopeService) {
  }

  hasUnsavedChanges(): boolean {
    return this.unsavedChanges;
  }

  saveChanges() {
    this.unsavedChanges = false;
  }

  startChanges() {
    this.unsavedChanges = true;
  }

  setMessage(message: string) {
    this.message = message;
  }

  resetMessage() {
    this.message = null;
  }

  verify(callback: Function) {
    if (this.hasUnsavedChanges()) {
      const data = { message: this.message };
      this.dialog.open(UnsavedChangesModalComponent, { data }).afterClosed().pipe(take(1)).subscribe((closedWithYes) => {
        if (closedWithYes) {
          this.saveChanges();
          callback();
        }
      });
    } else {
      callback();
    }
  }

  ask(callback: Function, message?: string) {
    const data = { message: message || this.message };
    this.dialog.open(UnsavedChangesModalComponent, { data }).afterClosed().pipe(take(1)).subscribe((closedWithYes) => {
      if (closedWithYes) {
        callback();
      }
    });
  }

  setModalOnLeave(callback?: Function): Function {
    const promptAsking = this.rootScope.onChangeStart((event, next) => {
      event.preventDefault();
      this.verify(() => {
        promptAsking();
        this.state.go(next.name)
        if (callback)
          callback();
      })
    });
    return promptAsking;
  }
}
